import { useEffect, useState } from "react";

import { formatCountdown } from "@/utils/date";

const useCountdown = (deadline: number) => {
  const [countdownInSeconds, setCountdownInSeconds] = useState<number>(deadline - Date.now());
  useEffect(() => {
    const timerId = setInterval(() => {
      if (Date.now() > deadline) return;
      setCountdownInSeconds(deadline - Date.now());
    }, 500);
    return () => clearInterval(timerId);
  });
  return formatCountdown(countdownInSeconds);
};

export default useCountdown;
